import React from 'react';
import { useEditorContext } from '../../Editor/Context';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import EverythingMenu from '../EverythingMenu';
import { MenuButtons as DeviationMenu } from '../../../extensions/extension-deviation/components/DaDeviationBubbleMenu/DaDeviationBubbleMenu';
import { MenuButtons as GalleryMenu } from '../../../extensions/extension-gallery/components/DaGalleryBubbleMenu/DaGalleryBubbleMenu';
import { MenuButtons as GifMenu } from '../../../extensions/extension-gif/components/DaGifBubbleMenu/DaGifBubbleMenu';
import { MenuButtons as VideoMenu } from '../../../extensions/extension-video/components/DaVideoBubbleMenu/DaVideoBubbleMenu';
import { MenuButtons as DeviationThumbMenu } from '../../../extensions/extension-deviation-thumb/components/DaDeviationThumbBubbleMenu/DaDeviationThumbBubbleMenu';

import s from './UniversalMobileMenu.scss';

export interface Props {
  noAtomics?: boolean;
  omitHRule?: boolean;
}

export enum MenuState {
  FORMAT,
}

const UniversalMobileMenu: React.FC<Props> = props => {
  const editor = useEditorContext();
  const forceUpdate = useForceUpdate();

  // Listen to editor as its not react so we need to react here
  editor?.on('transaction', () => {
    forceUpdate();
  });

  if (!editor) {
    return null;
  }

  // Deviation plugin menu states
  if (editor.storage['da-deviation'].menuState === 1) {
    return (
      <div className={s['plugin-menu-root']}>
        <DeviationMenu editor={editor} forMobile />
      </div>
    );
  }

  // Gallery plugin menu states
  if (editor.storage['da-gallery'].menuState === 1) {
    return (
      <div className={s['plugin-menu-root']}>
        <GalleryMenu editor={editor} forMobile />
      </div>
    );
  }

  // Gif plugin menu states
  if (editor.storage['da-gif'].menuState === 1) {
    return (
      <div className={s['plugin-menu-root']}>
        <GifMenu editor={editor} forMobile />
      </div>
    );
  }

  // Video plugin menu states
  if (editor.storage['da-video'].menuState === 1) {
    return (
      <div className={s['plugin-menu-root']}>
        <VideoMenu editor={editor} forMobile />
      </div>
    );
  }

  // Deviation thumb plugin menu states
  if (editor.storage['da-deviation-thumb'].menuState === 1) {
    return (
      <div className={s['plugin-menu-root']}>
        <DeviationThumbMenu editor={editor} forMobile />
      </div>
    );
  }

  // Main formatting menu states
  const menuState = MenuState.FORMAT;
  let menu;
  switch (menuState) {
    case MenuState.FORMAT:
    default:
      menu = (
        <EverythingMenu
          wrapping={false}
          noAtomics={props.noAtomics}
          omitHRule={props.omitHRule}
        />
      );
      break;
  }

  return <div>{menu}</div>;
};
UniversalMobileMenu.displayName = 'UniversalMobileMenu';

export default UniversalMobileMenu;
